<template>
  <div :class="['wrapper', orderType ? 'space-between' : '']">
    <div v-if="orderType" class="score">
      <div class="item arbitrage-price">
        <div>套现空间</div>
        ￥{{ detailInfo.arbitragePrice }}
      </div>

      <div v-if="detailInfo.budgetAmount && Number(detailInfo.budgetAmount) > 0" class="item budget-price">
        <div>客户首付预算</div>
        ￥{{ detailInfo.budgetAmount }}
      </div>
    </div>

    <div class="submit-btn">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-check"
        @click="submitResult(1)"
      >
        通过
      </el-button>

      <el-button
        type="danger"
        size="small"
        icon="el-icon-delete"
        @click="submitResult(2)"
      >
        拒绝
      </el-button>

      <el-button
        type="info"
        size="small"
        icon="el-icon-close"
        @click="submitResult(3)"
      >
        取消
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuditResult",
  props: {
    orderScoreProfile: {
      type: Object,
      default: () => {},
    },
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    orderType() {
      let orderType = this.$route.query.orderType;
      return orderType == 2 || orderType == 4;
    },
  },

  methods: {
    submitResult(val) {
      let orderType = this.$route.query.orderType;
      if (
        (orderType == 2 || orderType == 4) &&
        !this.orderScoreProfile.finalHitGrade &&
        val == 1
      ) {
        this.$alert("用户评级不能为空", "提示", {
          confirmButtonText: "确定",
          type: "warning",
        });
        return;
      }
      this.$emit("result", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper ::v-deep {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  .score {
    display: flex;
    align-items: center;
    gap: 16px;
    
    .item {
      color: #fff;
      border-radius: 8px;
      font-size: 14px;
      padding: 8px 16px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      }

      .value {
        font-size: 24px;
        font-weight: 600;
        margin: 0 4px;
      }
    }
  }
  
  .content {
    margin-top: 20px;
    
    .item {
      display: flex;
      margin: 15px 0;
      align-items: flex-start;
      
      & > span {
        &:first-child {
          white-space: nowrap;
          margin-right: 10px;
          color: #606266;
          font-weight: 500;
        }
      }
      
      &:nth-child(n + 2) {
        & > span {
          &:first-child {
            width: 100px;
            text-align: right;
            flex-shrink: 0;
          }
          &:last-child {
            flex: 1;
          }
        }
      }
    }
    
    .tips {
      margin: 5px 0;
      font-size: 15px;
      color: #303133;
    }
  }
  
  .submit-btn {
    display: flex;
    gap: 12px;
    align-items: center;
    
    .el-button {
      border-radius: 6px;
      padding: 10px 20px;
      font-weight: 500;
      transition: all 0.3s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }
  
  .el-dialog {
    border-radius: 12px;
    
    .el-dialog__header {
      padding: 20px 24px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 18px;
        font-weight: 700;
        color: #1a1e25;
      }
    }
    
    .el-dialog__body {
      padding: 24px;
      
      .el-textarea__inner {
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: all 0.3s ease;
        
        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
      }
      
      .el-checkbox-group,
      .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        
        .el-checkbox,
        .el-radio {
          margin-right: 0;
          
          .el-checkbox__label,
          .el-radio__label {
            padding-left: 8px;
          }
        }
      }
    }
    
    .el-dialog__footer {
      padding: 16px 24px;
      background: #fafbfc;
      border-top: 1px solid #f0f2f5;
      
      .el-button {
        border-radius: 6px;
        padding: 10px 20px;
        font-weight: 500;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
  
  .my-waring {
    color: #f56c6c;
    font-weight: 600;
    font-size: 18px;
  }
  
  .tit {
    margin: 10px 0;
  }
}

.space-between {
  justify-content: space-between;
}

.arbitrage-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  min-width: 140px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f56c6c 0%, #d05252 100%);
  font-weight: 500;
  
  div:first-child {
    font-size: 12px;
    opacity: 0.9;
    margin-bottom: 4px;
  }
}

.budget-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  min-width: 140px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #67c23a 0%, #47A8B4 100%);
  font-weight: 500;
  
  div:first-child {
    font-size: 12px;
    opacity: 0.9;
    margin-bottom: 4px;
  }
}
</style>
